import { z } from 'zod';
import { HttpErrorResponse } from './validation-error';
const LegacyResponse = z.object({}).passthrough();
export const getHealthcheckRoute = {
    version: 1,
    method: 'GET',
    path: '/healthcheck',
    name: 'healthcheck',
    request: {},
    responses: { 200: z.string() },
};
export const getStreakStatsRoute = {
    version: 1,
    method: 'GET',
    path: '/streak-stats/',
    name: 'get-streak-stats',
    request: {},
    responses: {
        200: z.object({
            streakDays: z.number(),
            maxStreak: z.number(),
            exercises: z.number(),
            aiMessages: z.number(),
            dailyStats: z.array(z.object({
                day: z.string(),
                status: z.enum(['complete', 'passed', 'today']),
            })),
        }),
        400: HttpErrorResponse,
    },
};
export const ProjectExample = z.object({
    contentTags: z.array(z.enum(['SQL', 'TABLEAU', 'LOOKER'])),
    companyType: z.enum([
        'Fintech',
        'Marketplace',
        'E-commerce',
        'B2B',
        'Consumer',
        'Other',
    ]),
    roleType: z.enum([
        'Marketing',
        'Sales',
        'Operations',
        'Product',
        'Customer Support',
        'Engineering',
        'Finance',
        'Other',
    ]),
    title: z.string(),
    description: z.string(),
    audienceType: z.enum(['Everyone', 'LendingHome', 'Fairmarkit']),
});
export const GetProjectExamplesResponse = z.object({
    examples: z.array(ProjectExample),
});
export const getProjectExamplesRoute = {
    version: 1,
    method: 'GET',
    path: '/project-examples/',
    name: 'get-project-examples',
    request: {},
    responses: { 200: GetProjectExamplesResponse, 400: HttpErrorResponse },
};
export const getTeamsActivityRoute = {
    version: 1,
    method: 'GET',
    path: '/tracks/{trackSlug}/missions/{missionSlug}/activities/{activitySlug}',
    name: 'get-activity',
    request: {
        params: z.object({
            trackSlug: z.string().min(1),
            missionSlug: z.string().min(1),
            activitySlug: z.string().min(1),
        }),
    },
    responses: {
        200: LegacyResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const getTeamsStatsRoute = {
    version: 1,
    method: 'GET',
    path: '/tracks/{trackSlug}/stats',
    name: 'get-stats',
    request: { params: z.object({ trackSlug: z.string().min(1) }) },
    responses: {
        200: LegacyResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
